import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Modal, Dropdown, Button} from 'semantic-ui-react';
import {hideNewReservedLocationsModal} from '../../actions/locationsAssignment';
import {startsWith} from '../../../common/util/dropdown';
import {parseFreeLocations} from '../../utils';
import './reservedLocationsSearch.scss';

class NewReservedLocationsSearchModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'locationsSelected': '',
    };
  }

  updateReservedLocations(value) {
    this.setState({'locationsSelected': value});
  }

  onCloseModalClick() {
    this.props.hideNewReservedLocationsModal();
  }

  onAcceptClick() {
    const {locationsSelected} = this.state;
    this.props.handleFieldChange(
      this.props.index,
      null,
      {'name': 'newReservedLocations', 'value': locationsSelected}
    );
    this.onCloseModalClick();
  }

  render() {
    const {open, freeLocations} = this.props;
    const {locationsSelected} = this.state;

    if (!open) {
      return null;
    }

    return (
      <Modal size='tiny'
        className='reserved-locations-search'
        open>
        <Modal.Header>
          Ubicaciones de reserva
        </Modal.Header>
        
        <Modal.Content>
          <Modal.Description>
            <Dropdown
              selection
              multiple
              search={startsWith}
              options={parseFreeLocations(freeLocations) || []}
              onChange={(e, {value}) => this.updateReservedLocations(value)}
              placeholder='Seleccione una ubicación'
              noResultsMessage='No existe la ubicación seleccionada'
            />

          </Modal.Description>
        </Modal.Content>

        <Modal.Actions>
          <Button onClick={() => this.onCloseModalClick()}>
            Cancelar
          </Button>
          <Button positive
            disabled={!locationsSelected}
            onClick={() => this.onAcceptClick()}>
            Aceptar
          </Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

const mapDispatchToProps = {
  'hideNewReservedLocationsModal': hideNewReservedLocationsModal,
};

const mapStateToProps = (state) => {
  return {
    'index': state.locationsAssignment.selectedIndex,
    'open': state.locationsAssignment.newReservedLocationsModal,
    'freeLocations': state.locationsAssignment.freeLocations,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(NewReservedLocationsSearchModal);
